import React from 'react';
import LCVHelpButton from './LCVHelpButton';

const LearningPhase = ({
  term,
  termIndex,
  onContinue,
  continueDisabled = false,
  continueLabel = 'Continue →',
}) => {
  return (
    <div className="lcv-learn-content">
      <div className="lcv-learn-card">
        <LCVHelpButton phase="learning" />
        <div className="lcv-learn-badge">
          <span className="lcv-learn-badge-dot" />
          LEARNING — TERM {termIndex + 1}
        </div>
        <h2 className="lcv-learn-term">{term.term}</h2>
        <p className="lcv-learn-def">{term.definition}</p>
        <div className="lcv-learn-example">
          <span className="lcv-learn-example-label">Example</span>
          {term.exampleSentence}
        </div>
      </div>
      <button
        className="lcv-btn-primary lcv-btn-full"
        onClick={onContinue}
        disabled={continueDisabled}>
        {continueLabel}
      </button>
    </div>
  );
};

export default LearningPhase;
